<template>
  <div class="video">
    <div class="title">{{ this.$store.state.monitorNum }}</div>
    <!-- <video
      id="my-video11"
      class="video-js vjs-default-skin video1"
      controls
      preload="auto"
      muted
      disablePictureInPicture
    > 
     <source src="" type="application/x-mpegURL" />
    </video>
    -->
    <div class="box-video">
      <video
        id="mse-video5"
        class="video1"
        :src="this.$store.state.videoSrc"
        loop="loop"
        autoplay
        muted
        playsinline
        controls
      ></video>
    </div>
    <div class="close" @click="close()"></div>
    <div class="video-bg"></div>
  </div>
</template>
<script>
export default {
  props: ["videoSrc"],
  data() {
    return {
      img: require("./../../../assets/img/play.png"),
      flag: false,
      // VideoSrc: "",
    
    };
  },
  mounted() {
    // this.initSlot();
    this.$nextTick(() => {
      // this.getVideoSrc();
    });
  },
  methods: {
    close() {
      this.$store.state.video = false;
      // document.querySelector('#mse-video5').dispose();
      // console.log(this.$store.state.video);
      // videojs("my-video11", function () {
      //   this.dispose();
      // });
      document.getElementById("iframe").contentWindow.MMAPI.none();
    },
    getVideoSrc() {
      let taht = this;
      let webrtc;
      function startPlay() {
        let videoEl = document.querySelector("#mse-video5");

        webrtc = new RTCPeerConnection({
          iceServers: [
            {
              urls: ["stun:stun.l.google.com:19302"],
            },
          ],
          sdpSemantics: "unified-plan",
        });
        webrtc.onnegotiationneeded = handleNegotiationNeeded;
        webrtc.ontrack = function (event) {
          console.log(event.streams.length + " track is delivered");
          videoEl.srcObject = event.streams[0];
          videoEl.play();
        };
        webrtc.addTransceiver("video", {
          direction: "sendrecv",
        });
        let webrtcSendChannel = webrtc.createDataChannel("sendchannel");
        // webrtc.addTransceiver('video', {
        //   'direction': 'sendrecv'
        // });
        webrtcSendChannel.onclose = () => {
          startPlay();
          console.log("sendChannel has closed");
        };
        webrtcSendChannel.onopen = () => {
          console.log("sendChannel has opened");
          webrtcSendChannel.send("ping");
          setInterval(() => {
            webrtcSendChannel.send("ping");
          }, 1000);
        };

        webrtcSendChannel.onmessage = (e) => console.log(e.data);
      }

      async function handleNegotiationNeeded() {
        let url = taht.$store.state.videoSrc;
        let offer = await webrtc.createOffer();

        await webrtc.setLocalDescription(offer);

        fetch(url, {
          method: "POST",
          body: new URLSearchParams({
            data: btoa(webrtc.localDescription.sdp),
          }),
        })
          .then((response) => response.text())
          .then((data) => {
            try {
              // console.log(data);
              webrtc.setRemoteDescription(
                new RTCSessionDescription({
                  type: "answer",
                  sdp: atob(data),
                })
              );
            } catch (e) {
              console.warn(e);
            }
          });
      }

    
        let videoEl = document.querySelector("#mse-video5");

        // videoEl.addEventListener("loadeddata", () => {
          videoEl.play();
        // });

        videoEl.addEventListener("error", (e) => {
          console.log("video_error", e);
        });

        startPlay();
      
    },
  },
  computed: {},
};
</script>
<style scoped>
.video {
  position: fixed;
  z-index: 999;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 9.85rem;
  height: 44vh;
  background: url("./../../../assets/img/video-bg.png") no-repeat;
  background-size: 100% 100%;
}
.title {
  position: absolute;
  font-size: 0.2rem;
  height: 0.38rem;
  width: 1.9625rem;
  top: 0.0625rem;
  left: 1.125rem;
  text-align: center;
  line-height: 0.35rem;
  font-family: "SourceHanSansCN";
  color: #bed8ff;
}
.play {
  width: 0.375rem;
  height: 0.375rem;
  position: absolute;
  bottom: 2%;
  left: 0.8125rem;
  background: url("./../../../assets/img/play.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
.close {
  width: 0.355rem;
  height: 0.355rem;
  border-radius: 50%;
  position: absolute;
  border: 1px solid #fff;
  top: 8%;
  right: 3%;
  background: url("./../../../assets/img/close.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  z-index: 999;
}
.box-video {
  position: absolute;
  width: 95.3%;
  height: 91%;
  top: 52%;
  left: 49.8%;
  transform: translate(-50%, -50%);
  background: black;
  box-sizing: border-box;
}
#mse-video5 {
  width: 100%;
  height: 100%;
}
</style>
